import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getProductKitItemListData,
  incrementParentKitNumKitItems,
  decrementParentKitNumKitItems,
} from './mockData'
import type { IProductKitItem } from '~/types/product/models'
import { apiEntityPath } from '~/services/productKitItems'

interface GetProductKitItemsResponse {
  data: IProductKitItem[]
}

async function getProductKitItems(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetProductKitItemsResponse = {
    data: await getProductKitItemListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postProductKitItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getProductKitItemListData,
    incrementParentKitNumKitItems
  )
}

const patchProductKitItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getProductKitItemListData)
}

const deleteProductKitItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getProductKitItemListData,
    decrementParentKitNumKitItems
  )
}

export const handlers = [
  {
    method: 'get',
    path: `${apiEntityPath}`,
    handler: getProductKitItems,
  },
  {
    method: 'post',
    path: `${apiEntityPath}`,
    handler: postProductKitItem,
  },
  {
    method: 'patch',
    path: `${apiEntityPath}/:id`,
    handler: patchProductKitItem,
  },
  {
    method: 'delete',
    path: `${apiEntityPath}/:id`,
    handler: deleteProductKitItem,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
